import { createSelector } from '@ngrx/store';

import { getOrderTypes } from '../getOrderTypes';

export const isDownloadingAnyOrderTypes = createSelector(getOrderTypes, (orderTypes) => orderTypes?.isDownloading);
